
export enum OrganizationRole {
  Developer = 0xA1,
  Administrator = 0xA2,
  Member = 0xA3,
}
